import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Resources: ParentMenuProps = {
  label: 'About',
  heapClass: 'au_topnav_resources',
  url: '/about'
}

export default Resources
